/* ak-media.js — music player + mini video player. Safe if either block is absent. */
(function () {
  'use strict';
  var $ = function (id) { return document.getElementById(id); };
  var fmt = function (s) { if (!isFinite(s)) return '0:00'; s = Math.floor(s); return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0'); };
  var store = { get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }, set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} } };

  /* ---------------- music ---------------- */
  var mp = $('mp'), audio = $('site-audio');
  if (mp && audio) {
    var fab = $('mp-fab'), minBtn = $('mp-min'), play = $('mp-play'), seek = $('mp-seek'), vol = $('mp-volume'), cur = $('mp-cur'), dur = $('mp-dur');
    var seeking = false;
    audio.volume = 0.7;
    var setState = function (s) { mp.setAttribute('data-state', s); fab.setAttribute('aria-expanded', s === 'open' ? 'true' : 'false'); store.set('ak_mp_state', s); };
    var sync = function () {
      var on = !audio.paused;
      mp.classList.toggle('is-playing', on);
      play.setAttribute('aria-label', on ? 'Pause' : 'Play');
    };
    var tryPlay = function () { var p = audio.play(); if (p && p.catch) p.catch(function () {}); };
    fab.addEventListener('click', function () { setState(mp.getAttribute('data-state') === 'open' ? 'min' : 'open'); });
    minBtn.addEventListener('click', function () { setState('min'); });
    play.addEventListener('click', function () { if (audio.paused) { tryPlay(); store.set('ak_mp_on', '1'); } else { audio.pause(); store.set('ak_mp_on', '0'); } });
    audio.addEventListener('play', sync); audio.addEventListener('pause', sync);
    audio.addEventListener('loadedmetadata', function () {
      dur.textContent = fmt(audio.duration);
      var t = parseFloat(store.get('ak_mp_t') || '0'); if (t && t < audio.duration) audio.currentTime = t;
    });
    audio.addEventListener('timeupdate', function () {
      if (!seeking && audio.duration) seek.value = Math.round(audio.currentTime / audio.duration * 1000);
      cur.textContent = fmt(audio.currentTime); store.set('ak_mp_t', String(audio.currentTime));
    });
    seek.addEventListener('input', function () { seeking = true; if (audio.duration) cur.textContent = fmt(seek.value / 1000 * audio.duration); });
    seek.addEventListener('change', function () { if (audio.duration) audio.currentTime = seek.value / 1000 * audio.duration; seeking = false; });
    vol.addEventListener('input', function () { audio.volume = vol.value / 100; });
    if (store.get('ak_mp_state') === 'open') setState('open');
    // browsers block autoplay: if it was playing on the last page, resume on the first interaction
    if (store.get('ak_mp_on') === '1') {
      var resume = function () { tryPlay(); document.removeEventListener('pointerdown', resume); document.removeEventListener('keydown', resume); };
      document.addEventListener('pointerdown', resume); document.addEventListener('keydown', resume);
    }
    sync();
  }

  /* ---------------- mini video ---------------- */
  var mv = $('mv'), vid = $('mv-video');
  if (mv && vid) {
    var pill = $('mv-pill'), vplay = $('mv-play'), vmute = $('mv-mute'), vbig = $('mv-big'), vclose = $('mv-close');
    var vstate = function (s) { mv.setAttribute('data-state', s); pill.setAttribute('aria-expanded', s === 'min' ? 'false' : 'true'); };
    var vsync = function () { mv.classList.toggle('is-playing', !vid.paused); vplay.setAttribute('aria-label', vid.paused ? 'Play video' : 'Pause video'); };
    var msync = function () { vmute.setAttribute('aria-pressed', vid.muted ? 'true' : 'false'); mv.classList.toggle('is-muted', vid.muted); vmute.setAttribute('aria-label', vid.muted ? 'Unmute video' : 'Mute video'); };
    pill.addEventListener('click', function () { vstate('mini'); });
    vclose.addEventListener('click', function () { vid.pause(); vstate('min'); });
    vplay.addEventListener('click', function () { if (vid.paused) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); } else vid.pause(); });
    vmute.addEventListener('click', function () { vid.muted = !vid.muted; msync(); });
    vbig.addEventListener('click', function () { vstate(mv.getAttribute('data-state') === 'big' ? 'mini' : 'big'); });
    $('mv-screen').addEventListener('click', function () { vplay.click(); });
    vid.addEventListener('play', vsync); vid.addEventListener('pause', vsync);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && mv.getAttribute('data-state') === 'big') vstate('mini'); });
    // never fight the music: starting the video with sound pauses the song
    vid.addEventListener('volumechange', function () { if (!vid.muted && audio && !audio.paused) audio.pause(); });
    msync(); vsync();
  }
})();
